import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { STATUS } from '../../../shared/enums';
import { addGlobalError } from '../root/rootSlice';
import { CustomKlaviyo } from "./CustomKlaviyo";

export const initialState = {
  data: null,
  status: STATUS.IDLE,
  error: null,
};

export const klaviyoSubscribe = createAsyncThunk('klaviyo/klaviyoSubscribe', async (payload, { rejectWithValue, dispatch }) => {
  const errorMessage = 'Something went wrong 😞';
  try {
    const { email } = payload;
    const customKlaviyo = new CustomKlaviyo(KLAVIYO_PUBLIC_API_KEY, NODE_ENV);
    const {
      success, message
    } = await customKlaviyo.subscribeOnMilaNews(email, KLAVIYO_WEBSITE_SUBSCRIBERS_LIST_ID);
    setTimeout(() => dispatch(klaviyoSlice.actions.clearKlaviyo()), 3000);
    return { title: success ? message : errorMessage }
  } catch (e) {

    dispatch(addGlobalError({ ...e.response?.data, status: e.response?.status }));
    return rejectWithValue({ error: errorMessage, status: STATUS.FAILED });
  }
});

export const klaviyoSlice = createSlice({
  name: 'klaviyo',
  initialState,
  reducers: {
    clearKlaviyo: state => {
      state.data = initialState.data;
      state.status = initialState.status;
      state.error = initialState.error;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(klaviyoSubscribe.pending, state => {
        state.status = STATUS.LOADING;
      })
      .addCase(klaviyoSubscribe.fulfilled, (state, action) => {
        state.status = IS_SERVER ? STATUS.PREFETCHED : STATUS.SUCCEEDED;
        state.data = action.payload;
        state.error = initialState.error;
      })
      .addCase(klaviyoSubscribe.rejected, (state, action) => {
        state.status = STATUS.FAILED;
        state.error = action.payload;
      });
  },
});

export const { clearKlaviyo } = klaviyoSlice.actions;

export const selectKlaviyoData = state => state.klaviyo.data;
export const selectKlaviyoStatus = state => state.klaviyo.status;
export const selectKlaviyoError = state => state.klaviyo.error;

export default klaviyoSlice.reducer;
